import request from '@/utils/request'

// 保存挑战记录
export function saveChallengeRecord(data) {
  return request({
    url: '/challenge-records',
    method: 'post',
    data
  })
}

// 查询指定时间范围最佳记录
export function getBestRecord(repoId, rangeType = 'all') {
  return request({
    url: '/challenge-records/best',
    method: 'get',
    params: { repoId, rangeType }
  })
}

// 查询排行榜
export function getLeaderboard(repoId, limit, rangeType = 'all') {
  return request({
    url: '/challenge-records/leaderboard',
    method: 'get',
    params: { repoId, limit: limit || 50, rangeType }
  })
}

// 查询指定时间范围内挑战记录明细
export function getChallengeRecords(repoId, rangeType = 'all') {
  return request({
    url: '/challenge-records/records',
    method: 'get',
    params: { repoId, rangeType }
  })
}
